// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__aH5ni","img":"Logo_img__G6-ha"};